import { getStaffRequest } from '../../../api/companies';
import { fetchInviteResources } from '../../../views/invites/utils/fetchInviteResources';
import { InviteFilterInviter, InviteFilterResource } from '../types';

const STAFF_LIMIT = 200;

/** Every team, location and pay schedule of the company, from the invite pickers */
export const fetchInviteFilterResources = async (companyId: string): Promise<InviteFilterResource[]> => {
  const { teams, locations, paySchedules } = await fetchInviteResources(companyId);
  return [
    ...teams.map(team => ({ uuid: team.uuid, name: team.name, type: 'team' as const })),
    ...locations
      .filter(location => !!location.uuid)
      .map(location => ({ uuid: location.uuid as string, name: location.name, type: 'location' as const })),
    ...paySchedules
      .filter(schedule => !!schedule.uuid)
      .map(schedule => ({
        uuid: schedule.uuid as string,
        name: schedule.name,
        type: 'pay_schedule' as const,
      })),
  ];
};

/**
 * Company staff — who can have sent an invite. Listing staff takes its own right, so this fails
 * for some managers; the filter then simply isn't offered.
 */
export const fetchInviteFilterInviters = async (companyId: string): Promise<InviteFilterInviter[]> => {
  const { data } = await getStaffRequest(companyId, { offset: 0, limit: STAFF_LIMIT });
  return (data?.items ?? []).map(staff => ({
    uuid: staff.user_id,
    name: `${staff.first_name ?? ''} ${staff.last_name ?? ''}`.trim() || staff.email || staff.phone,
  }));
};
